<template>
    <div>
        <a-row type="flex" justify="end" class="mb-15">
            <a-dropdown v-model="visibleDropdown">
                <a-button icon="eye">{{ lang.brands.columns }}</a-button>
                <a-menu slot="overlay">
                    <a-menu-item
                        v-for="(field, key) in fields.filter(f => f.dataIndex !== 'url')"
                        v-show="field.dataIndex !== 'id'"
                        :key="key">
                        <a-checkbox v-model="columns[key]" :value="field.dataIndex">
                            {{ field.title }} <a-icon v-show="!columns[key]" type="eye-invisible"/>
                        </a-checkbox>
                    </a-menu-item>
                </a-menu>
            </a-dropdown>
        </a-row>
        <a-table
            bordered
            size="middle"
            :columns="fields.filter((field, key) => columns[key])"
            :loading="isLoading"
            :data-source="paginated.data"
            :row-key="(record, index) => index">
            <!-- ------------------------------
                TABLE TITLE & REFRESH BUTTON
            ------------------------------- -->
            <template #title>
                <a-row type="flex" align="middle" justify="space-between">
                    <a-col>
                        <h2 class="mb-0">{{ lang.brands.brands }}</h2>
                    </a-col>
                    <a-col>
                        <a-row type="flex" :gutter="8">
                            <a-col class="my-sm-2 w-sm-100p">
                                <a-button block @click="toggleModal('add_brand')">
                                    {{ lang.brands.add_brand }}
                                </a-button>
                            </a-col>
                            <a-col class="my-sm-2 w-sm-100p">
                                <a-button block @click="fetchBrands({ force: true })">
                                    {{ lang.brands.refresh }}
                                </a-button>
                            </a-col>
                        </a-row>
                    </a-col>
                </a-row>
            </template>

            <template #created_at="date">
                {{ new Date(date).toLocaleDateString() }}
            </template>

            <template #see_brand="id">
                <a-button type="link" @click="setBrand(id)">{{ lang.brands.see_brand }}</a-button>
            </template>

            <template #status="status">
                {{ lang.brands.status_string[`${status}`] }}
            </template>

            <template #delete="id">
                <a-popconfirm
                    :title="lang.brands.remove_brand_popconfirm.title"
                    :ok-text="lang.brands.remove_brand_popconfirm.ok_button"
                    :cancel-text="lang.brands.remove_brand_popconfirm.cancel_button"
                    @confirm="remove(id)">
                    <a-button type="danger" icon="close" shape="circle"/>
                </a-popconfirm>
            </template>
        </a-table>

        <a-modal :title="lang.brands[state]" :visible="visible" :footer="null" mask-closable @cancel="toggleVisible">
            <a-form class="login-form" @submit.prevent="state === 'add_brand' ? create(form) : update(form)">
                <a-row type="flex" :gutter="8" justify="space-between">
                    <a-col style="flex-grow: 1;">
                        <a-form-item :label="lang.brands.name_label" :validate-status="hasError('name') ? 'error' : ''" has-feedback :help="getTranslatedError('name')">
                            <a-input id="name" :placeholder="lang.brands.name_placeholder" v-model="form.name" @keyup="removeError('name')">
                                <a-icon slot="prefix" type="skin" style="color: rgba(0,0,0,.25)" />
                            </a-input>
                        </a-form-item>
                        <a-form-item :label="lang.brands.field_display_name" :validate-status="hasError('display_name') ? 'error' : ''" has-feedback :help="getTranslatedError('display_name')">
                          <a-input id="name" :placeholder="lang.brands.field_display_name_placeholder" v-model="form.display_name" @keyup="removeError('display_name')"/>
                        </a-form-item>
                        <a-form-item :label="lang.brands.field_label" :validate-status="hasError('field') ? 'error' : ''" has-feedback :help="getTranslatedError('field')">
                            <a-input id="name" :placeholder="lang.brands.field_placeholder" v-model="form.field" @keyup="removeError('field')"/>
                        </a-form-item>
                        <a-form-item :label="lang.brands.field_id_label" :validate-status="hasError('index') ? 'error' : ''" has-feedback :help="getTranslatedError('index')">
                            <a-input id="name" :placeholder="lang.brands.field_id_placeholder" v-model="form.index" @keyup="removeError('index')"/>
                        </a-form-item>
                        <a-form-item :label="lang.brands.image_folders_List_label" :validate-status="hasError('image_folders') ? 'error' : ''" has-feedback :help="getTranslatedError('image_folders')">
                            <ATag v-for="(chip, i) of chips" :key="chip" class="chip" closable @close="deleteChip(i)">
                                <span>{{ chip }}</span>
                                <!--                            <span v-for="oneChip in chip.split(',')" v-text="oneChip" :key="oneChip"></span>-->
                                <!--                            <CloseCircleOutlined @click="deleteChip(i)"/>-->
                            </ATag>
                            <a-input type="number" id="name" :placeholder="lang.brands.image_folders_list_placeholder" v-model="currentInput" @keyup="removeError('image_folders')" @keypress.space="saveChip"/>
                        </a-form-item>
<!--                        <div >-->
<!--                        </div>-->
                        <a-form-item :label="lang.brands.status_label">
                            <a-checkbox v-model="form.status">
                                {{ lang.brands.status }}: <b>[{{ lang.brands.status_string[`${form.status}`] }}]</b>
                            </a-checkbox>
                        </a-form-item>
                    </a-col>
                </a-row>
                <a-form-item>
                    <a-button :loading="isLoading" type="primary" html-type="submit" class="login-form-button" block>{{ lang.brands.confirm }}</a-button>
                </a-form-item>
            </a-form>
        </a-modal>
    </div>
</template>

<script>
import { mapGetters, mapState, mapMutations, mapActions } from 'vuex'
export default {
    data: () => ({
        form: { name: '', display_name: '', field: '', index: '', image_folders: [], status: false },
        state: 'add_brand',
        columns: [],
        visibleDropdown: false,
        chips: [],
        currentChip: '',
        currentInput: ''
    }),
    computed: {
        ...mapState({
            visible: state => state.brand.visible,
            isLoading: state => state.brand.isLoading,
            paginated: state => state.brand.paginated,
        }),
        ...mapGetters({
            lang: 'lang',
            fields: 'brand/fields',
            hasError: 'hasError',
            getTranslatedError: 'getTranslatedError'
        })
    },
    methods: {
        ...mapActions({
            fetchBrands: 'brand/fetchBrands',
            create: 'brand/create',
            update: 'brand/update',
            remove: 'brand/remove',
            removeError: 'removeError'
        }),
        ...mapMutations({
            toggleVisible: 'brand/TOGGLE_VISIBLE'
        }),
        toggleModal(type = 'update_brand') {
            this.state = type
            this.form = { name: '', display_name: '', field: '', index: '', image_folders: [], status: false }
            this.toggleVisible()
        },
        setBrand(id) {
            let found = this.paginated.data.find(brand => brand.id === id)
            if (found) {
                this.toggleModal()
                let brand = {...found}
                this.form = brand
            }
        },
        saveChip() {
            const {chips, currentInput, set} = this;
            ((set && chips.indexOf(currentInput) === -1) || !set) && chips.push(currentInput.trim());
            this.currentInput = '';
            this.form.image_folders = this.chips
        },
        deleteChip(index) {
            this.chips.splice(index, 1);
            this.form.image_folders = this.chips
        }
    },
    mounted() {
        this.fetchBrands({ force: false, page: this.$route.query.page });
        this.columns = this.fields.filter(f => f.dataIndex !== 'url').map(() => true)
    }
}
</script>
